import { CapacityRestrictionEntity } from 'Models/Entities';
import { isNullOrUndefined } from 'Util/TypeGuards';

interface ICapacityTypeForCheckInDto {
	id: string;
	order?: number;
	label: string;
	description: string;
	abbreviation: string;
	iconName: string;
	hideCapacity: boolean;
	hideCapacityOnTripCards: boolean;

	/**
	 * Contains only the direct properties of the capacity types.
	 * We don't expect nested objects to be included.
	 */
	capacityRestrictions: CapacityRestrictionEntity[];
	cargoCharacteristicIds: string[];
	additionalBookingOptionId?: string;
}

export class CapacityTypeForCheckInDto implements ICapacityTypeForCheckInDto {
	id: string;
	order?: number;
	label: string;
	description: string;
	abbreviation: string;
	iconName: string;
	hideCapacity: boolean;
	hideCapacityOnTripCards: boolean;

	capacityRestrictions: CapacityRestrictionEntity[] = [];
	additionalBookingOptionId?: string;
	cargoCharacteristicIds: string[] = [];

	public constructor(attributes?: Partial<ICapacityTypeForCheckInDto>) {
		this.assignAttributes(attributes);
	}

	private assignAttributes(attributes?: Partial<ICapacityTypeForCheckInDto>) {
		if (isNullOrUndefined(attributes)) {
			return;
		}
		if (attributes.id !== undefined) {
			this.id = attributes.id;
		}
		if (attributes.order !== undefined) {
			this.order = attributes.order;
		}
		if (attributes.label !== undefined) {
			this.label = attributes.label;
		}
		if (attributes.description !== undefined) {
			this.description = attributes.description;
		}
		if (attributes.abbreviation !== undefined) {
			this.abbreviation = attributes.abbreviation;
		}
		if (attributes.iconName !== undefined) {
			this.iconName = attributes.iconName;
		}
		if (attributes.hideCapacity !== undefined) {
			this.hideCapacity = attributes.hideCapacity;
		}
		if (attributes.hideCapacityOnTripCards !== undefined) {
			this.hideCapacityOnTripCards = attributes.hideCapacityOnTripCards;
		}

		if (attributes.capacityRestrictions !== undefined && Array.isArray(attributes.capacityRestrictions)) {
			for (const model of attributes.capacityRestrictions) {
				if (model instanceof CapacityRestrictionEntity) {
					this.capacityRestrictions.push(model);
				} else {
					this.capacityRestrictions.push(new CapacityRestrictionEntity(model));
				}
			}
		}
		if (attributes.additionalBookingOptionId !== undefined) {
			this.additionalBookingOptionId = attributes.additionalBookingOptionId;
		}
		if (attributes.cargoCharacteristicIds !== undefined && Array.isArray(attributes.cargoCharacteristicIds)) {
			this.cargoCharacteristicIds = attributes.cargoCharacteristicIds;
		}
	}
}
